const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const getTime = require('mn-utils/time');
const {
  replaceLocation,
  path$,
} = require('../../../../../router');
const {
  paramStore,
} = require('../../../../../stores');


function timerStartInner(timerEnd) {
  function update() {
    const time = timerEnd - getTime();
    time < 0
      ? timerEmit(0)
      : (
        setTimeout(update, 1000),
        timerEmit(time)
      );
  }
  update();
}


const limit$ = paramStore('l', 60);
const timerEnd$ = paramStore('e', 0);
export const verificationLoading$ = new Emitter(0);
export const timer$ = new Emitter(0);
export const disabledResendVerificationCode$ = timer$.map((v) => !!v);
const timerEmit = timer$.emit;

((timerEnd) => {
  timerEnd - getTime() > 0 && timerStartInner(timerEnd);
})(timerEnd$.getValue());


export function resendVerificationCode(limit) {
  verificationLoading$.emit(1);
  const limitDef = limit$.getValue();
  limit = limit || limitDef;

  const timerEnd = getTime() + limit * 1000;
  const query = {};
  limit && limit !== limitDef && (query.l = limit);
  limit && (query.e = timerEnd);

  replaceLocation({
    path: path$.getValue(),
    query: query,
  });

  timerStartInner(timerEnd);
  return CancelablePromise.delay(500)
      .then(verificationLoading$.bind(0));
}
